<template>
  <LModal
    :visible="actionModalVisible"
    class="task-modal"
    centered
    size="lg"
    :disabled="readOnly"
    ok-variant="success"
    :ok-disabled="readOnly"
    :title="title"
    :submit="
      async () => {
        if (readOnly) return { success: false };
        await $emit('ok');
        return { success: true };
      }
    "
    @observer:valid="$emit('observer:valid', $event)"
    @update:visible="hide"
  >
    <template #modal-header="{ close }">
      <h5>{{ title }}</h5>
      <div>
        <i class="fas fa-times cursor-pointer" @click="close" />
      </div>
    </template>
    <FieldsIHOrderModalComponent
      :action="action"
      :action-type="actionType"
      :event="event"
      :board-id="boardId"
      :disabled="readOnly"
      @save="$emit('ok')"
    >
      <slot />
    </FieldsIHOrderModalComponent>
  </LModal>
</template>

<script setup lang="ts">
import { type PropType, computed } from "vue";
import { ActionType, type EventListEventFieldsFragment } from "@/graphql";
import FieldsIHOrderModalComponent from "@/modules/ih/components/FieldsIHOrderModalComponent.vue";
import LModal from "@/components/LModal.vue";
import usePropsAsDefault from "@/functions/usePropsAsDefault";
import type { IHOrderEditType } from "../../task/helper/DefaultTask";
import { useSpecifiedBoardContext } from "@/modules/sqdc/helper/EABConfigHelper";
import { hasRight } from "@/functions/authorizationState";

const props = defineProps({
  createMode: {
    type: Boolean,
    required: true,
  },
  action: {
    type: Object as PropType<IHOrderEditType>,
    required: true,
  },
  actionType: {
    type: String as PropType<ActionType>,
    required: true,
  },
  event: {
    type: Object as PropType<EventListEventFieldsFragment> | null,
    default: null,
  },
  title: {
    type: String,
    required: true,
  },
  loading: {
    type: Boolean,
    default: false,
  },
  visible: {
    type: Boolean,
    default: false,
  },
});
const emit = defineEmits(["ok", "update:visible", "observer:valid"]);
const actionModalVisible = usePropsAsDefault({
  dynamicProps: computed(() => props.visible),
  replace: true,
});
const show = () => {
  actionModalVisible.value = true;
  emit("update:visible", false);
};
const hide = () => {
  actionModalVisible.value = false;
  emit("update:visible", false);
};

const boardId = computed(
  () =>
    props.event?.boardConnection.find((con) => con.status === 0)?.boardId ??
    props.event?.boardConnection[0].boardId,
);
const { siteId } = useSpecifiedBoardContext(boardId);
const readOnly = computed(
  () => props.event?.deletedAt != null || !hasRight("sqdc.write", siteId.value),
);

defineExpose({
  show,
  hide,
});
</script>

<style lang="scss" scoped>
.toolTip {
  text-align: start;
  margin-left: -1.5rem;
  margin-bottom: 0;
}
</style>
